import type { PageId } from "@/components/common/types";

export const CREATION_TAB_META_PAGE_ID = {
  chatbots: "myCharacters",
  groups: "myGroups",
  lorebooks: "myLorebooks",
  rulebooks: "myRulebooks",
  voices: "myVoices",
} as const satisfies Record<string, PageId>;

export type CreationTabKey = keyof typeof CREATION_TAB_META_PAGE_ID;

export const resolveCreationTab = ({ pagePath }: { pagePath: string }): CreationTabKey => {
  const pathSegment = pagePath.slice(pagePath.lastIndexOf("/") + 1);
  if (pathSegment in CREATION_TAB_META_PAGE_ID) {
    return pathSegment as CreationTabKey;
  }
  return "chatbots";
};
